import { _ as r } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { c } from "./index-8b07dec9.js";
import m from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as y } from "./getMetrics-953aa4f8.js";
import { jsx as A } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var $t = /* @__PURE__ */ function(t) {
  return t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t;
}({}), Dt = /* @__PURE__ */ function(t) {
  return t.Display1 = "display-1", t.Display2 = "display-2", t.Display3 = "display-3", t;
}({}), o = /* @__PURE__ */ function(t) {
  return t.Display1 = "display-1", t.Display2 = "display-2", t.Display3 = "display-3", t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t.H6 = "h6", t.Title = "title", t.Subtitle = "sub-title", t.P = "p", t.Ul = "ul", t.Ol = "ol", t.Li = "li", t.A = "a", t.Caption = "caption", t;
}({}), n, z = ["className", "fontWeight"], P = ["className", "fontWeight"], L = ["className", "fontWeight"], S = ["className", "fontWeight"], U = ["className", "fontWeight"], M = ["className", "fontWeight"], q = ["className", "fontWeight"], E = ["className", "fontWeight"], k = ["className", "fontWeight"], B = ["className", "fontWeight"], F = ["className"], J = ["className", "fontWeight", "size"], K = ["className"], Q = ["className"], R = ["className", "fontWeight", "size"], V = ["className"], X = ["className", "fontWeight"], Y = ["renderAs", "styleType"], d = /* @__PURE__ */ m.h1.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = r(t, z);
  return Object.assign({}, i, {
    className: c("Text", e, "display-1", a)
  });
}).withConfig({
  displayName: "text__Display1",
  componentId: "sc-1s7o8tw-0"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h1;
}), f = /* @__PURE__ */ m.h2.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = r(t, P);
  return Object.assign({}, i, {
    className: c("Text", e, "display-2", a)
  });
}).withConfig({
  displayName: "text__Display2",
  componentId: "sc-1s7o8tw-1"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h2;
}), x = /* @__PURE__ */ m.h3.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = r(t, L);
  return Object.assign({}, i, {
    className: c("Text", e, "display-3", a)
  });
}).withConfig({
  displayName: "text__Display3",
  componentId: "sc-1s7o8tw-2"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h3;
}), N = /* @__PURE__ */ m.h1.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = r(t, S);
  return Object.assign({}, i, {
    className: c("Text", e, a)
  });
}).withConfig({
  displayName: "text__H1",
  componentId: "sc-1s7o8tw-3"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h1;
}), g = /* @__PURE__ */ m.h2.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = r(t, U);
  return Object.assign({}, i, {
    className: c("Text", e, a)
  });
}).withConfig({
  displayName: "text__H2",
  componentId: "sc-1s7o8tw-4"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h2;
}), v = /* @__PURE__ */ m.h3.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = r(t, M);
  return Object.assign({}, i, {
    className: c("Text", e, a)
  });
}).withConfig({
  displayName: "text__H3",
  componentId: "sc-1s7o8tw-5"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h3;
}), W = /* @__PURE__ */ m.h4.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = r(t, q);
  return Object.assign({}, i, {
    className: c("Text", e, a)
  });
}).withConfig({
  displayName: "text__H4",
  componentId: "sc-1s7o8tw-6"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h4;
}), T = /* @__PURE__ */ m.h5.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = r(t, E);
  return Object.assign({}, i, {
    className: c("Text", e, a)
  });
}).withConfig({
  displayName: "text__H5",
  componentId: "sc-1s7o8tw-7"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h5;
}), _ = /* @__PURE__ */ m.h6.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "medium" : s, i = r(t, k);
  return Object.assign({}, i, {
    className: c("Text", e, a)
  });
}).withConfig({
  displayName: "text__H6",
  componentId: "sc-1s7o8tw-8"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h6;
}), w = /* @__PURE__ */ m.h4.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "medium" : s, i = r(t, B);
  return Object.assign({}, i, {
    className: c("Text", e, "title", a)
  });
}).withConfig({
  displayName: "text__Title",
  componentId: "sc-1s7o8tw-9"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h4;
}), H = /* @__PURE__ */ m.h5.attrs(function(t) {
  var e = t.className, s = r(t, F);
  return Object.assign({}, s, {
    className: c("Text", e, "sub-title")
  });
}).withConfig({
  displayName: "text__SubTitle",
  componentId: "sc-1s7o8tw-10"
})(function(t) {
  var e = t.theme.components.richText;
  return e.h5;
}), b = /* @__PURE__ */ m.p.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = t.size, h = i === void 0 ? "medium" : i, p = r(t, J);
  return Object.assign({}, p, {
    className: c("Text", e, a, h + "-text")
  });
}).withConfig({
  displayName: "text__P",
  componentId: "sc-1s7o8tw-11"
})(function(t) {
  var e = t.theme.components.richText;
  return e.p;
}), O = /* @__PURE__ */ m.ul.attrs(function(t) {
  var e = t.className, s = r(t, K);
  return Object.assign({}, s, {
    className: c("Text", e)
  });
}).withConfig({
  displayName: "text__Ul",
  componentId: "sc-1s7o8tw-12"
})(function(t) {
  var e = t.theme.components.richText;
  return e.ul;
}), C = /* @__PURE__ */ m.ol.attrs(function(t) {
  var e = t.className, s = r(t, Q);
  return Object.assign({}, s, {
    className: c("Text", e)
  });
}).withConfig({
  displayName: "text__Ol",
  componentId: "sc-1s7o8tw-13"
})(function(t) {
  var e = t.theme.components.richText;
  return e.ol;
}), j = /* @__PURE__ */ m.li.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = t.size, h = i === void 0 ? "medium" : i, p = r(t, R);
  return Object.assign({}, p, {
    className: c("Text", e, a, h + "-text")
  });
}).withConfig({
  displayName: "text__Li",
  componentId: "sc-1s7o8tw-14"
})(function(t) {
  var e = t.theme.components.richText;
  return e.p;
}), I = /* @__PURE__ */ m.a.attrs(function(t) {
  var e = t.className, s = r(t, V);
  return Object.assign({}, s, {
    className: c("Text", e)
  });
}).withConfig({
  displayName: "text__A",
  componentId: "sc-1s7o8tw-15"
})(function(t) {
  var e = t.theme.components.richText;
  return e.a;
}), $ = /* @__PURE__ */ m.caption.attrs(function(t) {
  var e = t.className, s = t.fontWeight, a = s === void 0 ? "regular" : s, i = r(t, X);
  return Object.assign({}, i, {
    className: c("Text", e, "caption", a)
  });
}).withConfig({
  displayName: "text__Caption",
  componentId: "sc-1s7o8tw-16"
})(function(t) {
  var e = t.theme.components.richText;
  return e.caption;
}), u = (n = {}, n[o.Display1] = d, n[o.Display2] = f, n[o.Display3] = x, n[o.H1] = N, n[o.H2] = g, n[o.H3] = v, n[o.H4] = W, n[o.H5] = T, n[o.H6] = _, n[o.Title] = w, n[o.Subtitle] = H, n[o.P] = b, n[o.A] = I, n[o.Ul] = O, n[o.Ol] = C, n[o.Li] = j, n[o.Caption] = $, n);
function l(t) {
  var e = t.renderAs, s = e === void 0 ? "p" : e, a = t.styleType, i = a === void 0 ? s : a, h = r(t, Y), p = y({
    label: "Text"
  }), D = u[i] || u[o.P];
  return /* @__PURE__ */ A(D, Object.assign({
    as: s
  }, p, h));
}
l.Display1 = d;
l.Display2 = f;
l.Display3 = x;
l.H1 = N;
l.H2 = g;
l.H3 = v;
l.H4 = W;
l.H5 = T;
l.H6 = _;
l.Title = w;
l.SubTitle = H;
l.P = b;
l.Ul = O;
l.Ol = C;
l.Li = j;
l.A = I;
l.Caption = $;
export {
  I as A,
  $ as Caption,
  d as Display1,
  f as Display2,
  x as Display3,
  Dt as DisplayTypoGraphy,
  N as H1,
  g as H2,
  v as H3,
  W as H4,
  T as H5,
  _ as H6,
  $t as HeadingTypoGraphy,
  j as Li,
  C as Ol,
  b as P,
  H as SubTitle,
  l as Text,
  w as Title,
  o as Typography,
  O as Ul
};
